import { ModuleManagerState } from "./model"

export const DEFAULT_STATE: ModuleManagerState = {}
